import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Settings, FolderOpen, Banknote, HelpCircle, Ticket, LogOut } from "lucide-react";

import ClientDropDown from "../DropDown/ClientDropDown";
import { withRouter } from "utils/withRouter";
import { GetZendeskURL, getWooCommerceBillingLink } from "redux/actions";
import { componentsClaimKey, claimOperations } from "utils/Constants";
import HelperFunctions from "utils/HelperFunctions";
import { trackPromise } from "react-promise-tracker";
import toast from "utils/toast";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailRoles: ["Administration", "ESPAdmin", "SMSAdmin"],
      email: localStorage.getItem("user.email"),
    };
  }

  static formatLastLogin(value) {
    if (!value) return "";
    const d = new Date(value);
    if (isNaN(d.getTime())) return "";
    return d.toLocaleString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }

  componentDidMount() {
    // Help link onclick is now handled inline on the DropdownMenuItem
  }

  onBillingLinkClicked = () => {
    trackPromise(
      this.props
        .getWooCommerceBillingLink(
          HelperFunctions.getCookie("selectedClientId")
        )
        .then((response) => {
          if (response.operationSuccessful) {
            window.open(response.content, "_blank");
          } else {
            toast.info(
              "We are setting up your Billing. Please try again in a while."
            );
          }
        })
    );
  };

  onHelpClicked = () => {
    const email = localStorage.getItem("user.email");
    const firstName = localStorage.getItem("user.firstName");
    const lastName = localStorage.getItem("user.lastName");
    const fullName = `${firstName !== "undefined" ? firstName : ""} ${
      lastName !== "undefined" ? lastName : ""
    }`.trim();
    if (typeof window.openko19 === "function") {
      window.openko19(fullName, email !== "undefined" ? email : "");
    }
  };

  render() {
    let isAllowFileManagement = this.props.menuList.filter(
      (item) => item.url === "/FileManagement"
    );

    return (
      <nav id="app-header">
        <div className="tw:flex tw:items-center tw:justify-end tw:w-full tw:px-4">
          <div className="tw:flex tw:items-center tw:gap-3">

            {/* User info + dropdown */}
            <div id="user-account" className="tw:flex tw:items-center tw:gap-2">
              <div className="tw:text-right tw:text-xs tw:text-gray-500">
                <p className="tw:!m-0 tw:leading-tight">
                  {this.props.user_information.userName}
                </p>
                {this.props.user_information.lastLoginDate && (
                  <p className="tw:!m-0 tw:leading-tight">
                    Last Login:{" "}
                    {Navbar.formatLastLogin(
                      this.props.user_information.lastLoginDate
                    )}
                  </p>
                )}
              </div>

              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <button className="tw:outline-none tw:focus:outline-none tw:cursor-pointer">
                    <span className="icon-people-div">
                      <i className="icon-people"></i>
                    </span>
                  </button>
                </DropdownMenuTrigger>

                <DropdownMenuContent align="end" className="tw:w-44 tw:z-[9999]">
                  <DropdownMenuItem
                    onClick={() => this.props.router.navigate("/Configuration")}
                    className="tw:flex tw:items-center tw:gap-2 tw:cursor-pointer"
                  >
                    <Settings className="tw:h-4 tw:w-4" />
                    Settings
                  </DropdownMenuItem>

                  {isAllowFileManagement && isAllowFileManagement.length > 0 && (
                    <DropdownMenuItem
                      onClick={() => this.props.router.navigate("/FileManagement")}
                      className="tw:flex tw:items-center tw:gap-2 tw:cursor-pointer"
                    >
                      <FolderOpen className="tw:h-4 tw:w-4" />
                      Files
                    </DropdownMenuItem>
                  )}

                  {HelperFunctions.validateClientUserClaim(
                    componentsClaimKey.Billing,
                    claimOperations.Read,
                    this.props.clientUserClaims
                  ) && (
                    <DropdownMenuItem
                      onClick={this.onBillingLinkClicked}
                      className="tw:flex tw:items-center tw:gap-2 tw:cursor-pointer"
                    >
                      <Banknote className="tw:h-4 tw:w-4" />
                      Billing
                    </DropdownMenuItem>
                  )}

                  <DropdownMenuItem
                    id="ko-launch"
                    onClick={this.onHelpClicked}
                    className="tw:flex tw:items-center tw:gap-2 tw:cursor-pointer"
                  >
                    <HelpCircle className="tw:h-4 tw:w-4" />
                    Help
                  </DropdownMenuItem>

                  <DropdownMenuItem
                    onClick={this.props.GetZendeskURL}
                    className="tw:flex tw:items-center tw:gap-2 tw:cursor-pointer"
                  >
                    <Ticket className="tw:h-4 tw:w-4" />
                    My Tickets
                  </DropdownMenuItem>

                  <DropdownMenuSeparator />

                  <DropdownMenuItem
                    onClick={() => this.props.router.navigate("/authentication/logout")}
                    className="tw:flex tw:items-center tw:gap-2 tw:cursor-pointer tw:text-inherit"
                  >
                      <LogOut className="tw:h-4 tw:w-4" />
                    Log Out
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            </div>

            {/* Client selector */}
            <div className="tw:min-w-[200px]">
              <ClientDropDown />
            </div>

          </div>
        </div>
      </nav>
    );
  }
}

function mapStateToProps(state) {
  return {
    menuList: state.configuration.menuList,
    user_information: state.common.user_information,
    clientUserClaims: state.common.clientUserClaims,
  };
}

export default withRouter(
  connect(mapStateToProps, {
    GetZendeskURL,
    getWooCommerceBillingLink,
  })(Navbar)
);
